module.exports = __webpack_public_path__ + "static/img/2.c8acd8a2.png";